import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
    },

    mapContainer: {},

    autoComplete_container: {},

    mapText: {
        color: "#353535",
        fontSize: "16px",
        letterSpacing: 0,
        marginBottom: "8px",
    },

    mobile_mapText: {
        color: "#353535",
        fontSize: "18px",
        fontWeight: 500,
        letterSpacing: 0,
    },
    boldText: {
        fontWeight: 700,
        textDecoration: "underline",
        cursor: "pointer",
    },

    markerIcon: {
        color: "red",
        fontSize: "36px !important",
    },

    mobile_map_wrapper: {
        height: "123vh",
        width: "100vw",
    },
}));

export default useStyles;
